import React from 'react';

export function Footer() {
  return (
    <div className='d-flex flex-column align-items-center mt-4'>
      <div className='text-dark-200 text-center'>
        We take security and privacy seriously. All of the data we collect is
        completely secure and confidential.
        <br></br>
        If you have any questions, please contact us at{' '}
        <a href='mailto:support@screenloop.com'>support@screenloop.com</a>.
      </div>
    </div>
  );
}
